import { render } from "./VerifyPersonalIdCard.vue?vue&type=template&id=5eb602f0"
import script from "./VerifyPersonalIdCard.vue?vue&type=script&lang=js"
export * from "./VerifyPersonalIdCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__